import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

/**
 * A layout's Edit button, offered from 768 px up only: a phone shows "Edit on a larger screen" in its place
 * (VisionPlatform specs/web-on-phones WOP-03). The button stays in the page, hidden, so a wider window shows it again.
 */
export function LayoutEdit({ children }: { children: ReactNode }) {
  const { t } = useTranslation();
  return (
    <>
      <span className="hidden md:contents">{children}</span>
      <p className="self-center text-sm text-gray-700 md:hidden">{t("common.editOnLarger")}</p>
    </>
  );
}
